/**
 * @file timeline 时间线
 * @author jc
 */
import React, { useMemo } from 'react';
import cls from 'classnames';
import TimelineItem from './timelineItem';
import { ConfigContext } from '../config-provider';
const _layout = {
    vertical: ' is-vertical',
    horizontal: ' is-horizontal'
};
const _number = {
    vertical: ' number-vertical',
    horizontal: ' number-horizontal'
};
const Timeline = ({ prefixCls: customizePrefixCls, mode = 'vertical', reverse = false, isNumber = false, className, style, children }) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('timeline', customizePrefixCls);
    // 整体样式布局
    const layout = useMemo(() => {
        let layoutClass = _layout[mode] || ' is-vertical';
        let numberClass = '';
        if (isNumber) {
            numberClass = _number[mode] || ' number-vertical';
        }
        return cls(prefixCls, layoutClass, numberClass, className);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, className, prefixCls]);
    // 列表
    const listContext = useMemo(() => {
        if (Array.isArray(children) && reverse) {
            return children.reverse();
        }
        return children;
    }, [children, reverse]);
    return <div className={layout} style={style}>{listContext}</div>;
};
Timeline.Item = TimelineItem;
export default Timeline;
